import React from 'react';

const StonewallLogo = ({ className = "h-10 w-10" }) => {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/Stonewall_logo.png`}
      alt="Stonewall Logo"
      className={className}
    />
  );
};

export default StonewallLogo;
